module.exports = __webpack_public_path__ + "static/media/left.8ec73408.svg";